import ProvedoresAnaliticosPage from '@/modules/workflow/ctrl-analiticos-provedor/pages/ProvedoresAnaliticosPage.vue'
import DetalheProvedorAnaliticoPage from '@/modules/workflow/ctrl-analiticos-provedor/pages/DetalheProvedorAnaliticoPage.vue'
const routes = [
  {
    path: 'analiticos',
    name: 'analiticos',
    component: ProvedoresAnaliticosPage
  },
  {
    path: 'analiticos/detalhe-provedor',
    name: 'analiticos/detalhe-provedor',
    component: DetalheProvedorAnaliticoPage
  },
]

export default routes
